import "../assets/css/circleLoader.css";

export const CircleLoader = () => {
  return (
    <div className="loaders">
      <div className="loader1">
        <span></span>
      </div>
    </div>
  );
};
